import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import coupon from "./modules/coupon";
import index from "./modules/index";
import address from "./modules/address";
import order from "./modules/order";
Vue.use(Vuex);
const config = {
  modules: {
    index,
    address,
    order,
    coupon
  },

  plugins: [createPersistedState()],
  state: {
    isLogin: false,
    phone: "",
    token: "",
  },
  getters: {
    isLogin: state => state.isLogin,
    token: state => state.token,
    phone: state => state.phone
  },
  mutations: {
    updateLogin(state, payload) {
      state.isLogin = payload;
    },
    updateToken(state, payload) {
      state.token = payload;
    },
    updatePhone(state, payload) {
      state.phone = payload;
    }
  },
  actions: {}
};
const store = new Vuex.Store(config);
export default store;
